<script setup lang="ts">
import { ref, watch } from 'vue';
import { useElementVisibility } from '@vueuse/core';
import { providePanelSlot, type Panel, type PanelSystem } from '@/composables/use-panels';

const props = defineProps<{
	panel: Panel;
	panels: PanelSystem;
}>();

providePanelSlot(props.panels, props.panel.uri);

const root = ref<HTMLElement | null>(null);
const isVisible = useElementVisibility(root);
// defer mounting the panel component until the slot first becomes visible — once mounted, stays mounted
const mounted = ref(false);

// sync IntersectionObserver visibility to the panel handle
watch(
	isVisible,
	(v) => {
		if (v) mounted.value = true;
		const handle = props.panels.handles.get(props.panel.uri);
		if (handle) handle.visible = v;
	},
	{ immediate: true },
);
</script>

<template>
	<div ref="root" class="h-full w-full">
		<component v-if="mounted" :is="panel.component" v-bind="panel.props ?? {}" />
	</div>
</template>
